import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { startRegisterSearchResult } from "./searchResultActions";
import { dispatchSearchFilterResults } from "../helpers/searchFilterDispatch.helper";
import { resolveFlowListQueryFromState } from "../helpers/flowModuleListQueryHelper";

/*Reorganizados*/

/* Metodos Principales */
export const experienceStartRegisterAdmin = (experience, navigate, returnTo) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_EXPERIENCE}`,
      "add",
      experience,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: experienceActions, experienceStartRegisterAdmin', { 'body': body });

    if (body.ok) {

      const experienceSaved = body.experience;

      dispatch(experienceRegisterAdmin(experienceSaved));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            const nextPath = typeof returnTo === "string" && returnTo.startsWith("/")
              ? returnTo
              : "/specialist-experience";
            navigate(nextPath);
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const experienceRegisterAdmin = (experience) => ({
  type: types.EXPERIENCE_START_REGISTER_ADMIN,
  payload: experience,
});

export const experienceStartUpdate = (experience, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_EXPERIENCE}`,
        `update/${experience.id}`,
        experience,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: experienceActions, experienceStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(experienceUpdated(experience));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        });

      } else {

        if (body.errors) {
          debugLogActions("inside errors", body.errors);
          const { catalogserie_id } = body.errors;

          if (catalogserie_id) {
            Swal.fire(t("titles.error"), catalogserie_id.msg, "error");
            
          }
        }

        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: experienceActions, experienceStartUpdate', { 'error': error });
    }
  };
};

const experienceUpdated = (experience) => {
  return {
    type: types.EXPERIENCE_UPDATE,
    payload: experience,
  };
};

export const experienceStartDelete = (id, onDeleted) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_EXPERIENCE}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
               debugLogActions(':: experienceActions, experienceStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(experienceDeleted(id));
                if (typeof onDeleted === "function") {
                  onDeleted();
                }
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: experienceActions, experienceStartDelete', { 'error': error });
    }
  };
};

const experienceDeleted = (id) => {
  return {
    type: types.EXPERIENCE_DELETE,
    payload: id,
  };
};

export const startLoadingExperiencesPaginated = (page, size) => {
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'experience');
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_EXPERIENCE}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

     debugLogActions(':: experienceActions, startLoadingExperiencesPaginated', { 'body': body });

    if (body.ok) {
      dispatch(loadingExperiencesPaginated(body.experiencesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingExperiencesPaginated = (experiencesPaginated) => ({
  type: types.EXPERIENCE_START_LOADING_PAGINATED,
  payload: experiencesPaginated,
});

export const startLoadingExperiencesByTextExperiencePaginated = (experience, page, size, catalogToFilter, indicatorToFilter = [], codeCiiuLevel1={}) => {
  return async (dispatch, getState) => {

     const searchInfo = {
      searchExperienceText: experience,
      codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: catalogToFilter,
      indicatorToFilter: indicatorToFilter,
    };

    dispatch(experienceIsLoading());

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_EXPERIENCE}`,
      `getByTextExperience/${page}/${size}`,
      searchInfo,
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: experienceActions, startLoadingExperiencesByTextExperiencePaginated', { 'body': body });

    if (body.ok) {

      dispatch(experienceIsLoadingFinish());

      dispatchSearchFilterResults(dispatch, body.filterResults);

      body.experiencesPaginated.experiencesP.forEach(element => {
        element.isSelected = false;
        element.isCompared = false;
      });

      dispatch(loadingExperiencesByTextExperiencePaginated(body.experiencesPaginated));

      const { totalItems, totalPages, currentPage, experiencesP } = body.experiencesPaginated;
      
            let index = 0;
            let registerIds = "";
            experiencesP.forEach(element => {
      
              if (index === 0) {
                registerIds = registerIds.concat(element.id);
              } else {
                registerIds = registerIds.concat(";", element.id);
              }
      
              index = index + 1;
            });
      
            const state = getState();
            const { searchInfo } = state.searchInfo;
      
            const searchResult = {
              filter_results: body.filterResults,
              total_items: totalItems,
              total_pages: totalPages,
              current_page: currentPage,
              search_results_ids: registerIds,
              deleted: false,
              searchinfo_id: searchInfo.id
            }
      
            dispatch(startRegisterSearchResult(searchResult));

    } else {

      dispatch(experienceIsLoadingFinish());
      
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingExperiencesByTextExperiencePaginated = (experiencesPaginated) => ({
  type: types.EXPERIENCE_START_LOADING_EXPERIENCE_PAGINATED,
  payload: experiencesPaginated,
});

export const startSearchingExperiencesPaginated = (textSearch, page, size) => {
  
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'experience');
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_EXPERIENCE}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

     debugLogActions(':: experienceActions, startSearchingExperiencesPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingExperiencesPaginated(body.experiencesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const searchingExperiencesPaginated = (experiencesPaginated) => ({
  type: types.EXPERIENCE_START_SEARCH_PAGINATED,
  payload: experiencesPaginated,
});

export const selectExperience = (experience) => ({
  type: types.EXPERIENCE_SELECT,
  payload: experience,
});

export const cleanExperiencesPaginatedS = () => ({
  type: types.EXPERIENCE_CLEAN_SEARCH_PAGINATED,
});

export const cleanExperiencesPaginatedP = () => ({
  type: types.EXPERIENCE_CLEAN_PAGINATED,
});

export const experienceSetSearchText = (searchText) => ({
  type: types.EXPERIENCE_SET_SEARCH_TEXT,
  payload: searchText,
});

export const experienceCleanSearchText = () => ({
  type: types.EXPERIENCE_CLEAN_SEARCH_TEXT,
});

export const experienceCleanSaved = () => ({
  type: types.EXPERIENCE_CLEAN_SAVED,
});

//Si van 13 Feb 2026
export const experienceListUpdateSelected = (id) => ({
  type: types.EXPERIENCE_LIST_UPDATE_SELECTED,
  payload: id
});

export const experienceListSelectAllLimit = () => ({
  type: types.EXPERIENCE_SELECT_ALL_LIMIT,
});

export const experienceCleanAllSelected = () => ({
  type: types.EXPERIENCE_CLEAN_ALL_SELECTED,
});

export const experienceCleanAllSelectedWithoutList = () => ({
  type: types.EXPERIENCE_CLEAN_ALL_WITHOUT_LIST,
});

export const experienceIsLoading = () => ({
  type: types.EXPERIENCE_IS_LOADING
});

export const experienceIsLoadingFinish = () => ({
  type: types.EXPERIENCE_IS_LOADING_FINISH
});

//No van Update 13 de Feb 2026

export const experienceGetMoreThanOneIsSelected = () => ({
  type: types.EXPERIENCE_GET_MORE_THAN_ONE_SELECTED
});

export const experienceGetNumberExperienceSelected = (countCompareFlag) => ({
  type: types.EXPERIENCE_LIST_SET_NUMBER_SELECTED,
  payload: countCompareFlag
});

export const cleanSearchInformation = () => ({
  type: types.EXPERIENCE_CLEAN_SEARCH_INFORMATION,
});
